<template>
	<div v-if="description" class="c-read-only" v-html="description" :class="{'disabled': (this.selectedVariant === null)}"></div>
</template>

<script>
import { mapGetters } from "vuex";
import { sampleAndPurchaseStates } from 'shared/settings/constants';

export default {
	name: "read-only-description",
	props: {
		description: {
			type: String,
			default: null
		},
	},
	computed: {
		...mapGetters({
			selectedVariant: 'getSelectedVariant',
		}),
		isVisible() {
			return Number(this.isAvailable) === sampleAndPurchaseStates.IS_READ_ONLY;
		}
	},
}
</script>
